import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { GitCompare, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ComparisonBadgeProps {
  count: number;
  onClear: () => void;
}

export const ComparisonBadge: React.FC<ComparisonBadgeProps> = ({ count, onClear }) => {
  const navigate = useNavigate();

  if (count === 0) return null;

  const handleViewComparison = () => {
    navigate('/compare');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 bg-card border border-border rounded-xl shadow-lg p-4">
      <div className="flex items-center gap-3">
        <Badge variant="secondary" className="flex items-center gap-2">
          <GitCompare className="w-4 h-4" />
          {count} bot{count !== 1 ? 's' : ''} to compare
        </Badge>
        
        <div className="flex gap-2">
          <Button
            size="sm"
            onClick={handleViewComparison}
            className="bg-primary "
          >
            Compare Now
          </Button>
          
          <Button
            size="sm"
            variant="ghost"
            onClick={onClear}
            className="hover:bg-destructive hover:text-destructive-foreground"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};